export default __webpack_public_path__ + "static/media/evo-title-cn.7789bec3.webp";